/**
 * Strata brand tokens — SINGLE SOURCE OF TRUTH.
 *
 * Renaming the platform (CLAUDE.md §2: "APP_NAME is configurable") must touch
 * ONLY this file. Tailwind theme (`tailwind.ts`) and every UI primitive consume
 * these tokens — no colour literal lives anywhere else.
 */

export const APP_NAME = 'LTM Energy - Goldfields Cockpit' as const;
/** Compact form for tight chrome (logo brand line, sidebar footer, PWA short_name, iOS title). */
export const APP_SHORT = 'LTM Energy' as const;
export const DESCRIPTOR = 'Energy & Productivity Intelligence' as const;

/** Brand colour palette (CLAUDE.md §2). Keys are the canonical token names. */
export const COLORS = {
  ink: '#0B2545', // primary navy — sidebar, headers
  'ink-2': '#0E2A4F', // sidebar surface
  'ink-3': '#13315C', // active nav row
  'app-bg': '#EEF2F7', // app background
  surface: '#FFFFFF',
  border: '#E3E8EF',
  grid: '#EDF1F6',
  gold: '#E8A41C', // energy accent / warnings
  cyan: '#1F94A6', // data / primary chart
  green: '#2E9E6B', // savings / good
  red: '#D1495B', // alerts
  purple: '#6C5CE7',
  text: '#1A2433', // primary text
  muted: '#5C6B7F',
  faint: '#93A0B0',
  'ink-text': '#C9D6E8', // text on navy
} as const;

export type ColorToken = keyof typeof COLORS;

/** Accent tokens usable by KpiTile and chart series. */
export const ACCENTS = ['gold', 'cyan', 'green', 'red', 'purple'] as const;
export type Accent = (typeof ACCENTS)[number];

/** Layout constants (CLAUDE.md §2 layout). */
export const LAYOUT = {
  sidebarWidth: 230, // px
  topbarHeight: 66, // px
  cardRadius: 14, // px — rounded-2xl
  gridGap: 20, // px — gap-5
} as const;

/** Inter font stack (self-hosted via @fontsource/inter). */
export const FONT_SANS = [
  'Inter',
  'ui-sans-serif',
  'system-ui',
  '-apple-system',
  'Segoe UI',
  'Roboto',
  'Helvetica Neue',
  'Arial',
  'sans-serif',
] as const;
